import * as React from "react"

/* eslint-disable react/jsx-props-no-spreading */
export const CapsLock = props => (
  <svg viewBox="0 0 512 512" {...props}>
    <circle
      cx={256.1}
      cy={255.9}
      r={235.7}
      fill="none"
      stroke="#fff"
      strokeWidth={40}
      strokeMiterlimit={10}
    />
    <path
      d="M357 212.4l-98.6-98.6-.2-.2c-2.1-2-5.5-2-7.6 0l-.2.2-98.6 98.6h0c-3.4 3.5-.9 9.4 3.9 9.4h38.4c3 0 5.5 2.5 5.5 5.5V304c0 3 2.5 5.5 5.5 5.5h98.5c3 0 5.5-2.5 5.5-5.5v-76.6c0-3 2.5-5.5 5.5-5.5h38.3c5.1-.1 7.6-6 4.1-9.5h0zm-58.8 4.5v70.2c0 6.3-5.1 11.5-11.5 11.5H222c-6.3 0-11.5-5.1-11.5-11.5v-64.7c0-6.3-5.1-11.5-11.5-11.5h-2.2c-10.2 0-15.4-12.4-8.1-19.6l57.5-57.5c4.5-4.5 11.8-4.5 16.2 0l57.5 57.5c7.2 7.2 2.1 19.6-8.1 19.6h-7.7c-3.2 0-5.9 2.7-5.9 6z"
      stroke="#fff"
      strokeWidth={20}
      strokeMiterlimit={10}
    />
    <path
      d="M209.1 349.5h89.5c3 0 5.5 2.5 5.5 5.5v33c0 3-2.5 5.5-5.5 5.5h-89.5c-3 0-5.5-2.5-5.5-5.5v-33c-.1-3.1 2.4-5.5 5.5-5.5z"
      fill="none"
      stroke="#fff"
      strokeWidth={30}
      strokeMiterlimit={10}
    />
  </svg>
)

export const Space = props => (
  <svg viewBox="0 0 512 512" {...props}>
    <circle
      cx={256.1}
      cy={255.9}
      r={235.7}
      fill="none"
      stroke="#fff"
      strokeWidth={40}
      strokeMiterlimit={10}
    />
    <path d="M410.1 210.4c-9.3 0-16.9 7.6-16.9 16.9v50.6H123.4v-50.6c0-9.3-7.6-16.9-16.9-16.9s-16.9 7.6-16.9 16.9v67.5c0 9.3 7.6 16.9 16.9 16.9h303.6c9.3 0 16.9-7.6 16.9-16.9v-67.5c0-9.3-7.5-16.9-16.9-16.9z" />
  </svg>
)

export const Delete = props => (
  <svg viewBox="0 0 512 512" {...props}>
    <circle
      cx={256.1}
      cy={255.9}
      r={235.7}
      fill="none"
      stroke="#fff"
      strokeWidth={40}
      strokeMiterlimit={10}
    />
    <path d="M377.7 167.8H180.6c-3 0-5.9 1.3-7.9 3.5l-73.1 80.2c-3.7 4.1-3.7 10.3 0 14.4l73.1 80.2c2 2.2 4.9 3.5 7.9 3.5h197.1c5.9 0 10.7-4.8 10.7-10.7V178.5c0-5.9-4.8-10.7-10.7-10.7zM367 328.2H185.3L122 258.7l63.3-69.5H367v139z" />
    <path d="M322.5 221.9c-4.2-4.1-11-4.1-15.1.1l-57.7 58.5c-4.1 4.2-4.1 11 .1 15.1 2.1 2.1 4.8 3.1 7.5 3.1 2.8 0 5.5-1.1 7.6-3.2l57.7-58.5c4.2-4.2 4.1-11-.1-15.1z" />
    <path d="M322.9 280l-58.5-57.7c-4.2-4.1-11-4.1-15.1.1-4.2 4.2-4.1 11 .1 15.1l58.5 57.7c2.1 2.1 4.8 3.1 7.5 3.1 2.8 0 5.5-1.1 7.6-3.2 4.1-4.2 4.1-11-.1-15.1z" />
  </svg>
)

export const Clear = props => (
  <svg viewBox="0 0 512 512" {...props}>
    <circle
      cx={256.1}
      cy={255.9}
      r={235.7}
      fill="none"
      stroke="#fff"
      strokeWidth={40}
      strokeMiterlimit={10}
    />
    <path d="M347.4 365.7c-4.7 0-9.4-1.8-12.9-5.4L151.6 177.5c-7.1-7.1-7.1-18.7 0-25.9 7.1-7.1 18.7-7.1 25.9 0l182.9 182.9c7.1 7.1 7.1 18.7 0 25.9-3.6 3.5-8.3 5.3-13 5.3z" />
    <path d="M164.6 365.7c-4.7 0-9.4-1.8-12.9-5.4-7.1-7.1-7.1-18.7 0-25.9l182.9-182.9c7.1-7.1 18.7-7.1 25.9 0 7.1 7.1 7.1 18.7 0 25.9l-183 183c-3.6 3.5-8.2 5.3-12.9 5.3z" />
  </svg>
)

export const Prev = props => (
  <svg viewBox="0 0 512 512" {...props}>
    <circle
      cx={256.1}
      cy={255.9}
      r={235.7}
      fill="none"
      stroke="#FFF"
      strokeWidth={40}
      strokeMiterlimit={10}
    />
    <path d="M374.3 243.2c-1.1-.2-2.2-.3-3.3-.2H180.7l4.1-1.9c4.1-1.9 7.7-4.5 10.9-7.7l53.3-53.3c7-6.7 8.2-17.5 2.8-25.6-6.3-8.6-18.4-10.5-27-4.2-.7.5-1.4 1.1-2 1.7l-96.5 96.5c-7.5 7.5-7.5 19.7 0 27.3l96.5 96.5c7.5 7.5 19.8 7.5 27.3 0 .6-.6 1.1-1.2 1.7-1.9 5.4-8.1 4.2-18.9-2.8-25.6l-53.2-53.4c-2.8-2.8-6.1-5.2-9.6-7l-5.8-2.6h189.4c9.9.4 18.5-6.5 20.4-16.2 1.7-10.7-5.4-20.7-15.9-22.4z" />
  </svg>
)

export const Next = props => (
  <svg viewBox="0 0 512 512" {...props}>
    <circle
      cx={256.1}
      cy={255.9}
      r={235.7}
      fill="none"
      stroke="#FFF"
      strokeWidth={40}
      strokeMiterlimit={10}
    />
    <path d="M137.1 281.1c1.1.2 2.2.3 3.3.2h190.2l-4.1 1.9c-4.1 1.9-7.7 4.5-10.9 7.7l-53.3 53.3c-7 6.7-8.2 17.5-2.8 25.6 6.3 8.6 18.4 10.5 27 4.2.7-.5 1.4-1.1 2-1.7l96.5-96.5c7.5-7.5 7.5-19.7 0-27.3L288.5 152c-7.5-7.5-19.8-7.5-27.3 0-.6.6-1.1 1.2-1.7 1.9-5.4 8.1-4.2 18.9 2.8 25.6l53.2 53.4c2.8 2.8 6.1 5.2 9.6 7l5.8 2.6H141.5c-9.9-.4-18.5 6.5-20.4 16.2-1.7 10.8 5.4 20.7 16 22.4z" />
  </svg>
)

export const Enter = props => (
  <svg viewBox="0 0 512 512" {...props}>
    <circle
      cx={256.1}
      cy={255.9}
      r={235.7}
      fill="none"
      stroke="#FFF"
      strokeWidth={40}
      strokeMiterlimit={10}
    />
    <path d="M376.5 194.5V242c0 4.8-3.9 8.6-8.6 8.6H183.6c-7.7 0-11.6-9.3-6.1-14.8l37.4-37.4c3.4-3.4 3.4-8.8 0-12.2l-10.4-10.5c-3.4-3.4-8.9-3.4-12.2 0l-84.9 84.9c-3.4 3.4-3.4 8.9 0 12.2l84.9 84.9c3.4 3.4 8.9 3.4 12.2 0l10.4-10.4c3.4-3.4 3.4-8.9 0-12.2l-37.4-37.4c-5.4-5.4-1.6-14.8 6.1-14.8h216.6c4.8 0 8.6-3.9 8.6-8.6v-79.9c0-4.8-3.9-8.6-8.6-8.6h-15.1c-4.7 0-8.6 3.9-8.6 8.7z" />
  </svg>
)